
import AppTabs from "@/components/layout-editor/Tabs.vue";
import Vue from "vue";
import { AuthService } from "@/services/auth-service";

export default Vue.extend({
	props: {
		value: Number
	},
	computed: {
		tabs(): ([number, string])[] {
			let result:([number, string])[] = [];
			if (this.fullControl) {
				result = [
					[0,"pageSettings"],
					[1,"heading"],
					[2,"textSettings"],
					[3,"logo"],
					[14, "qr-codes"],
					[15, "barcodes"],
					[4,"titleLine"],
					[5,"dateLine"],
					[6,"sale-detail"],
					[7,"totalLine"],
					[13,"vatLines"],
					[8,"freeLines"],
					[9,"freeBlocks"],
					[16, "payments"],
					[10,"saleRequirments"],
					[11,"attachment"]
				];
			}else{
				result = [
					[0,"pageSettings"],
					[1,"heading"],
					[2,"textSettings"],
					[3,"logo"],
					[6,"sale-detail"],
					[7,"totalLine"],
					[10,"saleRequirments"],
				];
			}
			result.forEach((t,i)=>{
				result[i][1] = this.$ct(t[1] as string).toString();
			});
			return result;

		},
		fullControl(): Boolean {
			if(AuthService.isDevModeEnabled || AuthService.hasModule(13)){
				return true;
			}
			return false;
		}
	},
	components: {
		AppTabs
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
